import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { Router } from "@closerplatform/bff/trpc";

export const rpc = createTRPCClient<Router>({
  links: [
    httpBatchLink({
      url: "/rpc",
    }),
  ],
});
